import _UAParser from 'ua-parser-js';

const UAParser = new _UAParser();

export function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
}

export function historyApiAvailable() {
    return !!window.history.pushState;
}

export function isIE() {
    return UAParser.getBrowser().name === 'IE';
}

export function isEdge() {
    return UAParser.getBrowser().name === 'Edge';
}

export function isSafari() {
    return UAParser.getBrowser().name === 'Safari';
}

export function isChrome() {
    return UAParser.getBrowser().name === 'Chrome';
}

export function isFirefox() {
    return UAParser.getBrowser().name === 'Firefox';
}

export function getBrowserName() {
    // convert to browser names that correspond to CSS classes used in our code:
    //     ie, safari, firefox, edge, chrome
    if (isIE()) {
        return 'ie';
    } else if (isEdge()) {
        return 'edge';
    } else if (isSafari()) {
        return 'safari';
    } else if (isChrome()) {
        return 'chrome';
    } else if (isFirefox()) {
        return 'firefox';
    }

    return 'other';
}

export function isMac() {
    return UAParser.getOS().name === 'Mac OS';
}

export function isWindows() {
    return UAParser.getOS().name === 'Windows';
}

export function isChromebook() {
    return UAParser.getOS().name === 'Chromium OS';
}

export function getOS() {
    if (isMac()) {
        return 'mac';
    } else if (isWindows()) {
        return 'windows';
    } else if (isChromebook()) {
        return 'chromebook';
    }

    return '';
}

export default {
    storageAvailable,
    historyApiAvailable,
    isIE,
    isEdge,
    isSafari,
    isChrome,
    isFirefox,
    getBrowserName,
    isMac,
    isWindows,
    isChromebook,
    getOS,
};
